import React, { isValidElement, ReactNode } from 'react'

export function getChildrenArray(children: ReactNode): ReactNode[] {
  if (!children) return []

  if (isValidElement(children)) {
    return React.Children.toArray(children.props?.children)
  }

  return React.Children.toArray(children)
}
